module.exports = __webpack_public_path__ + "img/x-close.ac6d1831.svg";